import { Helmet } from "react-helmet-async";
import { Layout } from "../../components/layout";
import {
  MyButton,
  CustomModal,
  Dropdown,
  LoadingSpinner,
  Input,
  Pagination,
  EmptyTable,
} from "../../components";
import { BsList, BsThreeDotsVertical } from "react-icons/bs";
import {
  Menu,
  MenuItem,
  Button,
  Select,
  IconButton,
} from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { DealsListController } from "../../controllers";
import { Cancel } from "../../../assets";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { FaAngleDown, FaFilter } from "react-icons/fa";
import CustomTabPanel from "../../components/custom_tab";
import DatePicker from "react-multi-date-picker";
import persian_fa from "react-date-object/locales/persian_fa";
import persian from "react-date-object/calendars/persian";
function CustomInput({
  onFocus,
  value,
  onChange,
  title,
  emptyState,
  error,
}: any) {
  return (
    <Input
      emptyState={emptyState}
      hideEndAdornment
      type="number"
      error={error}
      onChange={onChange}
      customFocus={onFocus}
      myStyle="w-100"
      title={title}
      value={value}
    />
  );
}
class DealsList extends DealsListController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getDealsList();
  }
  render() {
    const {
      transactionsList,
      loading,
      subject,
      to_date,
      from_date,
      errorsList,
      page,
      stagesList,
      stage,
      selectedItem,
      count,
      rowsCountList,

      filterModal,
      dealStage,
      dealStagesList,
      dealState,
      dealStatesList,
      openEditModal,
      openAddModal,
    } = this.state;
    return (
      <>
        <Layout title="معاملات">
          <Helmet>
            <title> معاملات | سامانه مشتریان</title>
          </Helmet>
          <div className="users-list">
            {loading ? (
              <LoadingSpinner />
            ) : (
              <>
                <>
                  <div className="users-list-headline mt-3">
                    <div className="">
                      <BsList color="#003366" className="ms-2" />{" "}
                      <span className="title">معاملات</span>
                    </div>
                    <div className="headline-btn-group d-flex ">
                      <MyButton
                        myStyle="add"
                        icon={<FaFilter className="ms-2" />}
                        title=" فیلترها"
                        onClick={() => this.handleOpenFilterModal()}
                      />
                    </div>
                  </div>
                  <div className="users-list-container">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>ردیف</TableCell>
                          <TableCell>مدل معامله</TableCell>
                          <TableCell>شرکت</TableCell>
                          <TableCell>اطلاعات</TableCell>
                          <TableCell>ارجاع به </TableCell>
                          <TableCell>مرحله</TableCell>
                          <TableCell>عملیات</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {!transactionsList?.list?.length && <EmptyTable />}
                        {transactionsList?.list?.map(
                          (item: any, index: number) => {
                            return (
                              <>
                                <TableRow
                                  key={index}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {index + 1}
                                  </TableCell>
                                  <TableCell>{item?.deal || "--"}</TableCell>
                                  <TableCell>{item?.company_name || "--"}</TableCell>
                                  <TableCell>{item?.brif || "--"}</TableCell>
                                  <TableCell>
                                    {item?.assgin_to || "--"}
                                  </TableCell>
                                  <TableCell>{item?.stage || "--"}</TableCell>
                                  <TableCell>
                                    <PopupState
                                      variant="popover"
                                      popupId="demo-popup-menu"
                                    >
                                      {(popupState: any) => (
                                        <>
                                          {/* <Button
                                            sx={{
                                              background: "#D4AF37",
                                              ":hover": {
                                                bgcolor: "#D4AF37",
                                              },
                                            }}
                                            variant="contained"
                                            {...bindTrigger(popupState)}
                                          >
                                            عملیات
                                          </Button> */}
                                          <IconButton
                                          sx={{
                                            color: "#0c1a58",
                                            padding: "4px"
                                          }}
                                          {...bindTrigger(popupState)}
                                        >
                                          <BsThreeDotsVertical />
                                        </IconButton>
                                          <Menu {...bindMenu(popupState)}>
                                            <MenuItem
                                              onClick={() =>
                                                this.handleChaneState(item)
                                              }
                                            >
                                              تغییر مرحله
                                            </MenuItem>
                                          <MenuItem
                                            onClick={() => {
                                              window.open(`/details-ticket/${item?.ticket_id}`, '_blank');
                                            }}
                                          >
                                            مشاهده تیکت
                                          </MenuItem>
                                          </Menu>
                                        </>
                                      )}
                                    </PopupState>
                                  </TableCell>
                                </TableRow>
                              </>
                            );
                          }
                        )}
                      </TableBody>
                    </Table>
                    <Pagination
                      count={
                        transactionsList?.pages ? transactionsList?.pages : 1
                      }
                      page={page}
                      total={transactionsList?.total}
                      pageNumber={transactionsList?.page_number}
                      onChangePage={this.handleChangePage}
                      rowsCountList={rowsCountList}
                      countValue={count}
                      onChangeCount={(value: any) => this.handleCount(value)}
                    />
                  </div>
                </>
              </>
            )}
            <CustomModal
              myStyle="one-field-modal"
              openModal={openEditModal}
              onClose={() =>
                this.setState({
                  openEditModal: !openEditModal,
                  errorsList: [],
                  stage: "",
                })
              }
            >
              <>
                <div className="custom-modal-main-title mb-2">
                  <div>
                    <h1 className="title">تغییر مرحله</h1>
                  </div>

                  <Cancel
                    myStyle="ps-2 "
                    width="20"
                    height="20"
                    color="#000000"
                    onClick={() =>
                      this.setState({
                        openEditModal: !openEditModal,
                        errorsList: [],
                        stage: "",
                      })
                    }
                  />
                </div>

                <div className="custom-modal-content">
                <div className="custom-modal-row">
                  <Dropdown
                    placeholder="یک گزینه را انتخاب کنید"
                    items={stagesList}
                    objectList
                    myStyle=" w-100"
                    error={
                      errorsList.filter(
                        (name: { path: string }) => name.path === "stage"
                      )?.[0]?.errors?.[0]
                    }
                    title="مرحله"
                    value={stage}
                    onChange={(e: any) => {
                      this.setState({ stage: e.target.value });
                    }}
                    emptyState={() => this.setState({ stage: "" })}
                  >
                    {stagesList &&
                      stagesList?.map((item: any, index: number) => {
                        return (
                          <MenuItem value={item?.id} key={index}>
                            {item?.title}
                          </MenuItem>
                        );
                      })}
                  </Dropdown>
                </div>
                <div className="custom-modal-confirm">
                  <MyButton
                    myStyle="bg-green"
                    title="تایید و ثبت"
                    loading={(this.state as any).isChangingStage}
                    onClick={() => this.handleChangeStage()}
                  />
                </div>
                </div>
              </>
            </CustomModal>
            <CustomModal
              myStyle="assign-modal add-task-modal custom-modal-overflow-hidden"
              openModal={filterModal}
              onClose={() =>
                this.setState({
                  filterModal: !filterModal,
                  dealStage: "",
                  dealState: "",
                })
              }
            >
              <>
                <div className="custom-modal-main-title mb-2">
                  <h1 className="custom-modal-title">فیلترها</h1>
                  <Cancel
                    myStyle="ps-2 cursor-pointer"
                    color="#000000"
                    onClick={() =>
                      this.setState({
                        filterModal: !filterModal,
                        dealStage: "",
                        dealState: "",
                      })
                    }
                  />
                </div>
                <div className="custom-modal-content">
                <div className="custom-modal-row ">
                  <Dropdown
                    placeholder="یک گزینه را انتخاب کنید"
                    items={dealStatesList}
                    objectList
                    myStyle=" w-100"
                    title="وضعیت معامله"
                    value={dealState}
                    onChange={(e: any) => {
                      this.setState({ dealState: e.target.value });
                    }}
                    emptyState={() => this.setState({ dealState: "" })}
                  >
                    {dealStatesList &&
                      dealStatesList?.map((item: any, index: number) => {
                        return (
                          <MenuItem value={item?.name} key={index}>
                            {item?.title}
                          </MenuItem>
                        );
                      })}
                  </Dropdown>
                </div>
                <div className="custom-modal-row cols-2">
                  <DatePicker
                    ref={this.datePickerRef}
                    render={
                      <CustomInput
                        title="از تاریخ"
                        emptyState={() => this.emptyFromDate()}
                      />
                    }
                    value={from_date}
                    dateSeparator=" تا "
                    calendar={persian}
                    locale={persian_fa}
                    placeholder=" از تاریخ "
                    containerClassName="custom-modal-item-w-50 filter-date-container"
                    inputClass="custom-date-input"
                    calendarPosition="top-right"
                    onChange={this.handleChangeFromDate}
                  />
                  <DatePicker
                    ref={this.datePickerRef}
                    render={
                      <CustomInput
                        title="تا تاریخ"
                        emptyState={() => this.emptyToDate()}
                      />
                    }
                    dateSeparator=" تا "
                    calendar={persian}
                    locale={persian_fa}
                    value={to_date}
                    calendarPosition="top-right"
                    placeholder="تا تاریخ"
                    containerClassName="custom-modal-item-w-50 filter-date-container"
                    inputClass="custom-date-input"
                    onChange={this.handleChangeToDate}
                  />
                </div>
                <div className="custom-modal-row mb-57">
                  <Dropdown
                    placeholder="یک گزینه را انتخاب کنید"
                    items={dealStagesList}
                    objectList
                    myStyle=" w-100"
                    title="مرحلهٔ معامله"
                    value={dealStage}
                    onChange={(e: any) => {
                      this.setState({ dealStage: e.target.value });
                    }}
                    emptyState={() => this.setState({ dealStage: "" })}
                  >
                    {dealStagesList &&
                      dealStagesList?.map((item: any, index: number) => {
                        return (
                          <MenuItem value={item?.name} key={index}>
                            {item?.title}
                          </MenuItem>
                        );
                      })}
                  </Dropdown>
                </div>

                <div className="custom-modal-confirm">
                  <MyButton
                    myStyle="bg-green"
                    title="اعمال"
                    loading={this.state.isFilterApplying}
                    onClick={() => this.getDealsList()}
                  />
                </div>
                </div>
              </>
            </CustomModal>
          </div>
        </Layout>
      </>
    );
  }
}
export default DealsList;
